import React from 'react';
import { Button, Box, Stack } from '@mui/material';
import { Clear, Refresh } from '@mui/icons-material';
import { reloadSamples } from '../services/api'

function ClassifyButton({ onClearAll, onReloadSamples }) {
  const handleReloadSamples = async () => {
    try {
      await reloadSamples();
      onReloadSamples(); // This should trigger a re-fetch of the file list
    } catch (error) {
      console.error('Error reloading samples:', error);
    }
  };

  return (
    <Stack sx={{ my: 2 }} direction="row" spacing={1}>
      <Button variant="outlined" color="secondary" onClick={onClearAll} startIcon={<Clear />}>
        清空图片
      </Button>
      <Button variant="outlined" color="secondary" onClick={handleReloadSamples} startIcon={<Refresh />}>
         加载测试图片
      </Button>
    </Stack>
  );
}

export default ClassifyButton;
